import { LayoutComponent } from './layouts/layout/layout.component';
import { VexRoutes } from '@vex/interfaces/vex-route.interface';
import { AuthGuard } from './core/auth/auth.guard';
import { NotFoundComponent } from './pages/pages/not-found/not-found.component';

export const appRoutes: VexRoutes = [

  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', loadComponent: () => import('./pages/pages/auth/login/login.component').then((m) => m.LoginComponent) },
  { path: 'register', loadComponent: () => import('./pages/pages/auth/register/register.component').then((m) => m.RegisterComponent) },
  //{ path: 'forgot-pass', loadComponent: () => import('./pages/pages/auth/forgot-pass/forgot-pass.component').then((m) => m.ForgotPassComponent) },
  { path: 'restart-pass', loadComponent: () => import('./pages/pages/auth/restartpass/restartpass.component').then((m) => m.RegisterComponent) },
  {
    path: 'home', component: LayoutComponent, canActivate: [AuthGuard], children: [
      { path: '', loadChildren: () => import('./pages/home/help-center/help-center.routes'), canActivate: [AuthGuard] },
      { path: '**', component: NotFoundComponent, canActivate: [AuthGuard] },
    ],
  },
  {
    path: 'gestion', component: LayoutComponent, canActivate: [AuthGuard], children: [
      { path: '', loadChildren: () => import('./pages/my-pqrs/my-pqrs.routes'), canActivate: [AuthGuard] },
      { path: '**', component: NotFoundComponent, canActivate: [AuthGuard] },
    ]
  },
  {
    path: 'mesa-de-ayuda', component: LayoutComponent, canActivate: [AuthGuard], children: [
      { path: '', loadChildren: () => import('./pages/options/help-desk/help-desk.routes'), canActivate: [AuthGuard] },
      { path: '**', component: NotFoundComponent, canActivate: [AuthGuard] },
    ]
  },
  {
    path: 'opciones-usuario', component: LayoutComponent, canActivate: [AuthGuard], children: [
      { path: 'perfil', loadChildren: () => import('./pages/options-user/profile/profile.routes'), canActivate: [AuthGuard] },
      { path: 'payment-methods', loadComponent: () => import('./pages/options-user/payment-methods/payment-methods.component').then((m) => m.PaymentMethodsComponent), canActivate: [AuthGuard] },
      { path: 'reminders', loadComponent: () => import('./pages/options-user/reminders/reminders.component').then((m) => m.RemindersComponent), canActivate: [AuthGuard] },
      { path: '**', component: NotFoundComponent, canActivate: [AuthGuard] },
    ]
  },
  { path: 'no-encontrada', component: NotFoundComponent },
  { path: '**', redirectTo: 'no-encontrada' }
];
